import React, { useState, useEffect, useCallback, useMemo } from 'react';
import DataTable from '../Components/DataTable/DataTable';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Controllers from '../Api/Controllers';
import { FormCustom, Input, CheckBox, Select } from '../Components/Form/Form';
import Helpers from '../Helpers/Helpers';
import { toast as toastr } from 'react-toastify';
import Firms from './Firms'
import { useSelector } from 'react-redux'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Address from './Address';
import ReactPlaceholder from 'react-placeholder';

const UnidadForm = ({ data, onSubmit, viewDisabled }) => {
  const {
    id = '',
    description = '',
    appear_in_acts = 0,
    is_executor = 0,
    id_entity = null,
    id_parent = null,
    name_request = '',
    profession_request = '',
    name_boss = '',
    profession_boss = '',
    address = '',
    unit_phone = '',
  } = data

  const profile_id = useSelector(store => store.session.id_profile)

  const [row, setRow] = useState({
    id,
    description,
    appear_in_acts,
    is_executor,
    id_entity,
    id_parent,
    name_request: '',
    profession_request: '',
    name_boss: '',
    profession_boss: '',
    address,
    unit_phone
  })
  const [exists, setExists] = useState(id !== '')
  const [entities, setEntities] = useState([])
  const [executors, setExecutors] = useState([])
  const [isOk, setIsOk] = useState(false)

  useEffect(() => {
    let promises = [
      Controllers.entity.get_entity(),
      Controllers.unit.get_unit_executors()
    ]
    Promise.all(promises).then(res => {
      setEntities(res[0].data.map(e => ({ value: e.id, label: e.description })))
      setExecutors(res[1].data.map(e => ({ value: e.id, label: e.description })))
      setIsOk(true)

      if (res[1].data.length === 1 && !row.id) {
        setRow({ ...row, is_executor: 0, id_parent: res[1].data[0].id })
      }
    })
  }, [])

  const dataSumbit = useCallback(() => {
    return {
      p_id: row.id,
      p_description: row.description,
      p_appear_in_acts: parseInt(row.appear_in_acts),
      p_is_executor: parseInt(row.is_executor) || 0,
      p_id_entity: parseInt(row.is_executor) === 1 ? row.id_entity : '',
      p_id_parent: parseInt(row.is_executor) === 1 ? '' : row.id_parent,
      p_name_request: row.name_request,
      p_profession_request: row.profession_request,
      p_name_boss: row.name_boss,
      p_profession_boss: row.profession_boss,
      p_address: row.address,
      p_unit_phone: row.unit_phone
    }
  }, [row])

  return <ReactPlaceholder showLoadingAnimation rows={7} type='text' ready={isOk}><FormCustom dataSubmit={dataSumbit()} viewSubmit={!viewDisabled} onSubmit={({ e, dataSubmit, callbackSuccess }) => {
    if (parseInt(row.is_executor) === 1 && !row.id_entity) {
      Helpers.toastr.construct({ response: 'warning', message: 'Seleccionar Entidad', toastr })
      return
    }
    if (parseInt(row.is_executor) === 0 && !row.id_parent) {
      Helpers.toastr.construct({ response: 'warning', message: 'Seleccionar Unidad Ejecutora', toastr })
      return
    }
    onSubmit({ e, dataSubmit, callbackSuccess })
  }} callbackSuccess={r => {
    if (r.id) {
      setExists(true)
    }
  }}>
    <Input
      text="ID"
      placeholder="ID"
      classNameParent="col-12 mb-2"
      icon="fa fa-code"
      required
      defaultValue={id}
      onChange={e => setRow({ ...row, id: e.currentTarget.value })}
      disabled={id !== '' || viewDisabled}
      pattern="[0-9]{1,11}"
      invalid="Solo números. Ej. 100100"
      maxLength={9}
    />
    <Input
      text="Descripción"
      placeholder="Descripción"
      classNameParent="col-12 mb-2"
      icon="far fa-comment-alt"
      required
      defaultValue={description}
      onChange={e => setRow({ ...row, description: e.currentTarget.value })}
      disabled={viewDisabled}
    />
    <CheckBox
      text="En Actas"
      classNameParent="col-12 mb-2"
      defaultChecked={parseInt(appear_in_acts) === 1}
      onChange={e => setRow({ ...row, appear_in_acts: e.currentTarget.checked ? 1 : 0 })}
      id="appear_in_acts-type-purchase"
      disabled={viewDisabled}
    />
    <Input
      text="Dirección"
      placeholder="Dirección"
      classNameParent="col-12 mb-2"
      icon="far fa-comment-alt"
      required
      defaultValue={address}
      onChange={e => setRow({ ...row, address: e.currentTarget.value })}
      disabled={viewDisabled}
    />
    <Input
      text="Teléfono de Unidad"
      placeholder="Teléfono"
      classNameParent="col-12 mb-2"
      icon="fa fa-phone"
      defaultValue={unit_phone}
      onChange={e => setRow({ ...row, unit_phone: e.currentTarget.value })}
      disabled={viewDisabled}
      maxLength={50}
    />
    {parseInt(profile_id) === 1 && <CheckBox
      text="¿Es Unidad Ejecutora?"
      classNameParent="col-12 mb-2"
      defaultChecked={parseInt(is_executor) === 1}
      onChange={e => setRow({ ...row, is_executor: e.currentTarget.checked ? 1 : 0, id_parent: '', id_entity: '' })}
      id="is_executor-unit"
      disabled={viewDisabled || id !== ''}
    />}
    {parseInt(row.is_executor) === 1 ? (
      <>
        {parseInt(profile_id) === 1 && <Select
          text="Entidad"
          classNameParent="col-12 mb-2"
          icon="fa fa-sitemap"
          options={entities}
          onChange={e => setRow({ ...row, id_entity: e ? e.value : '' })}
          isClearable
          disabled={viewDisabled || id !== ''}
          value={row.id_entity ? { value: row.id_entity, label: entities.find(e => e.value === parseInt(row.id_entity))?.label } : ''}
        />}
      </>
    ) : (
      executors.length > 0 && <Select
        text="Unidad Ejecutora"
        classNameParent="col-12 mb-2"
        icon="fa fa-building"
        options={executors}
        onChange={e => setRow({ ...row, id_parent: e ? e.value : '' })}
        isClearable
        disabled={viewDisabled || id !== ''}
        value={row.id_parent ? { value: row.id_parent, label: executors.find(e => parseInt(e.value) === parseInt(row.id_parent))?.label } : ''}
      />
    )}
    <Input
      text="Nombre Solicitante"
      placeholder="Nombre Solicitante"
      classNameParent="col-6 mb-2 d-none"
      icon="far fa-comment-alt"
      defaultValue={name_request}
      onChange={e => setRow({ ...row, name_request: e.currentTarget.value })}
      maxLength={255}
      disabled={viewDisabled}
    />
    <Input
      text="Cargo Solicitante"
      placeholder="Cargo Solicitante"
      classNameParent="col-6 mb-2 d-none"
      icon="far fa-comment-alt"
      defaultValue={profession_request}
      onChange={e => setRow({ ...row, profession_request: e.currentTarget.value })}
      maxLength={255}
      disabled={viewDisabled}
    />
    <Input
      text="Nombre Jefe"
      placeholder="Nombre Jefe"
      classNameParent="col-6 mb-2 d-none"
      icon="far fa-comment-alt"
      defaultValue={name_boss}
      onChange={e => setRow({ ...row, name_boss: e.currentTarget.value })}
      maxLength={255}
      disabled={viewDisabled}
    />
    <Input
      text="Cargo Jefe"
      placeholder="Cargo Jefe"
      classNameParent="col-6 mb-2 d-none"
      icon="far fa-comment-alt"
      defaultValue={profession_boss}
      onChange={e => setRow({ ...row, profession_boss: e.currentTarget.value })}
      maxLength={255}
      disabled={viewDisabled}
    />
  </FormCustom>
    {exists ? <>
      <div className="mt-4"></div>
      <Firms idUnit={row.id} />
      <div className="mt-4"></div>
      <Address idUnit={row.id} />
    </> : ''}
  </ReactPlaceholder>
}

const Unidad = () => {
  const permissions = useSelector(store => store.session.permissions)
  const actionsModule = Helpers.getActions({ permissions, name: 'centroscosto' })

  const nameModulo = 'Centros De Costo'
  const namePage = 'Centro De Costo'
  const nameController = 'unit'

  const [rows, setRows] = useState([]);
  const [isProcessing, setIsProcessing] = useState(true);
  const [modalSize, setModalSize] = useState('');
  const [modalShow, setModalShow] = useState(false);
  const [modalHeader, setModalHeader] = useState('');
  const [modalTitle, setModalTitle] = useState('');
  const [form, setForm] = useState('');
  const [reload, setReload] = useState(true);

  useEffect(() => {
    if (reload) {
      Controllers[nameController]['get_' + nameController]().then(res => {
        setRows(res.data)
      })
        .finally(() => {
          setIsProcessing(false)
          setReload(false);
        });
    }
  }, [reload])

  const handleUpdate = useCallback(e => {
    const { id = '', disabled = 0 } = e.currentTarget.dataset;
    let button = e.currentTarget
    let buttonHTML = button.innerHTML;
    button.innerHTML = Helpers.icon.spin()

    setModalTitle(parseInt(disabled) === 1 ? <><i className={'mr-2 ' + actionsModule.view.icon}></i>{actionsModule.view.description} {namePage}</> : (id ? <><i className={'mr-2 ' + actionsModule.update.icon}></i>{actionsModule.update.description} {namePage}</> : <><i className={'mr-2 ' + actionsModule.create.icon}></i>{actionsModule.create.description} {namePage}</>))
    setModalSize('xl');
    setModalHeader('');

    Controllers[nameController]['get_' + nameController + '_id']({ p_id: id }).then(res => {
      setForm(<UnidadForm data={res.data} viewDisabled={parseInt(disabled) === 1} onSubmit={onSubmit} />);
      setModalShow(true);
    }).catch(req => {
      Helpers.promise.catch({ req, toastr });
      setModalShow(false);
    }).finally(() => button.innerHTML = buttonHTML)
  }, [actionsModule])

  const onSubmit = ({ e, dataSubmit, callbackSuccess }) => {
    let $this = e.currentTarget

    let propsValidateForm = { form: $this, toastr };
    if (!$this.checkValidity()) {
      $this.classList.add('was-validated');
      Helpers.form.isFormCorrect(propsValidateForm);
      return;
    } else {
      $this.classList.remove('was-validated');
      if (!Helpers.form.isFormCorrect(propsValidateForm)) {
        return;
      }
    }

    let button = $this.querySelector('button[type=submit]');
    let buttonHTML = button.innerHTML
    button.innerHTML = Helpers.icon.spin();

    Controllers[nameController][nameController + '_insert_update'](dataSubmit).then(res => {
      Helpers.toastr.construct({ response: res.response, message: res.message, toastr });
      callbackSuccess(res.data)
    }).catch(req => {
      Helpers.promise.catch({ req, toastr });
    }).finally(() => {
      button.innerHTML = buttonHTML;
      setReload(true)
    });
  }

  const onDelete = e => {
    const { id = '' } = e.currentTarget.dataset;
    setModalTitle(<><i className="fa fa-trash mr-2"></i> Eliminar {namePage}</>);
    setModalHeader('bg-danger');
    setModalSize('sm');
    setForm(<div className="d-flex flex-column align-items-center">
      <p><strong>¿Eliminar {namePage} #{id}?</strong></p>

      <div>
        <Button variant="danger" className="mr-2" size="sm" onClick={e => {
          let button = e.currentTarget
          let buttonHTML = button.innerHTML;
          button.innerHTML = Helpers.icon.spin()

          Controllers[nameController][nameController + '_delete']({
            p_id: id
          }).then(res => {
            Helpers.toastr.construct({ response: res.response, message: res.message, toastr });
          }).catch(req => {
            Helpers.promise.catch({ req, toastr });
          }).finally(() => {
            button.innerHTML = buttonHTML;
            setReload(true)
            setModalShow(false);
          });
        }}>
          <i className="fa fa-check mr-2"></i>Si
        </Button>
        <Button variant="dark" className="mr-2" size="sm" onClick={() => setModalShow(false)}>
          <i className="fa fa-times mr-2"></i>No
        </Button>
      </div>
    </div>);
    setModalShow(true)
  }

  const dtRows = useMemo(() => {
    const thead = [
      { name: 'Unidad Ejecutora' },
      { name: 'Centro de Costo' },
      { name: 'En Actas', align: 'center' },
      { name: 'Acc.', align: 'center' }
    ];

    // Agrupar: cada UE como cabecera, hijos por parent_description
    const executors = rows.filter(r => parseInt(r.is_executor) === 1).sort((a,b) => (a.description||'').localeCompare(b.description||''))
    const children = rows.filter(r => parseInt(r.is_executor) !== 1)
    const groups = []
    executors.forEach(ue => {
      const childs = children
        .filter(c => (c.parent_description||'') === (ue.description||''))
        .sort((a,b) => (a.description||'').localeCompare(b.description||''))
      groups.push({ header: ue, items: childs })
    })
    // Orfanatos (sin UE en el set): listarlos como su propia “cabecera”
    const orphans = children
      .filter(c => !executors.find(ue => (ue.description||'') === (c.parent_description||'')))
      .sort((a,b) => (a.parent_description||'').localeCompare(b.parent_description||''))
    orphans.forEach(c => groups.push({ header: { id: 'h-' + c.id, description: c.parent_description || '(Sin UE)' }, items: [c] }))

    return <DataTable
      pageLenght={100}
      isProcessing={isProcessing}
      tbody={groups}
      thead={thead}
      render={tbody => tbody.flatMap(g => {
        const out = []
        // Fila cabecera (colspan)
        out.push(<tr className="table-active">
          <td colSpan={4}>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <strong>Unidad Ejecutora:</strong> {g.header.description || ''}
              </div>
              <div>
                {!isNaN(parseInt(g.header.id)) && actionsModule.view ? <OverlayTrigger
                  placement="top"
                  overlay={props => <Tooltip {...props}>
                    {actionsModule.view.description}
                  </Tooltip>}
                >
                  <Button variant={actionsModule.view.color} data-disabled={1} size="xs" className="mr-1" data-id={g.header.id} onClick={handleUpdate}>
                    <i className={actionsModule.view.icon}></i>
                  </Button>
                </OverlayTrigger> : ''}
                {!isNaN(parseInt(g.header.id)) && actionsModule.update ? <OverlayTrigger
                  placement="top"
                  overlay={props => <Tooltip {...props}>
                    {actionsModule.update.description}
                  </Tooltip>}
                >
                  <Button variant={actionsModule.update.color} size="xs" className="mr-1" data-id={g.header.id} onClick={handleUpdate}>
                    <i className={actionsModule.update.icon}></i>
                  </Button>
                </OverlayTrigger> : ''}
                {!isNaN(parseInt(g.header.id)) && actionsModule.delete ? <OverlayTrigger
                  placement="top"
                  overlay={props => <Tooltip {...props}>
                    {actionsModule.delete.description}
                  </Tooltip>}
                >
                  <Button variant={actionsModule.delete.color} size="xs" data-id={g.header.id} onClick={onDelete}>
                    <i className={actionsModule.delete.icon}></i>
                  </Button>
                </OverlayTrigger> : ''}
              </div>
            </div>
          </td>
        </tr>)
        // Hijos
        g.items.forEach(r => {
          out.push(<tr>
            <td></td>
            <td>{r.description}</td>
            <td align="center"><strong className={'text-' + (parseInt(r.appear_in_acts) === 1 ? 'success' : 'danger')}>{parseInt(r.appear_in_acts) === 1 ? 'SI' : 'NO'}</strong></td>
            <td align="center">
              {actionsModule.view ? <OverlayTrigger
                placement="top"
                overlay={props => <Tooltip {...props}>
                  {actionsModule.view.description}
                </Tooltip>}
              >
                <Button variant={actionsModule.view.color} data-disabled={1} size="xs" className="mr-1" data-id={r.id} onClick={handleUpdate}>
                  <i className={actionsModule.view.icon}></i>
                </Button>
              </OverlayTrigger> : ''}
              {actionsModule.update ? <OverlayTrigger
                placement="top"
                overlay={props => <Tooltip {...props}>
                  {actionsModule.update.description}
                </Tooltip>}
              >
                <Button variant={actionsModule.update.color} size="xs" className="mr-1" data-id={r.id} onClick={handleUpdate}>
                  <i className={actionsModule.update.icon}></i>
                </Button>
              </OverlayTrigger> : ''}
              {actionsModule.delete ? <OverlayTrigger
                placement="top"
                overlay={props => <Tooltip {...props}>
                  {actionsModule.delete.description}
                </Tooltip>}
              >
                <Button variant={actionsModule.delete.color} size="xs" data-id={r.id} onClick={onDelete}>
                  <i className={actionsModule.delete.icon}></i>
                </Button>
              </OverlayTrigger> : ''}
            </td>
          </tr>)
        })
        // Espaciador visual
        out.push(<tr><td colSpan={4}>&nbsp;</td></tr>)
        return out
      })}
    />
  }, [isProcessing, rows, handleUpdate, actionsModule])

  return <>
    <Card>
      <Card.Header className="justify-content-between">
        <span>Listado De {nameModulo}</span>
        {actionsModule.create ? <Button onClick={handleUpdate} variant={actionsModule.create.color} size="sm"><i className={actionsModule.create.icon}></i><span className="ml-2 d-none d-md-inline-block">{actionsModule.create.description} {namePage}</span></Button> : ''}
      </Card.Header>
      <Card.Body>
        {dtRows}
      </Card.Body>
    </Card>
    <Modal show={modalShow} onHide={() => setModalShow(false)} size={modalSize} backdrop="static">
      <Modal.Header closeButton className={modalHeader}>
        <Modal.Title as="div">{modalTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {form}
      </Modal.Body>
    </Modal>
  </>
}

export default Unidad;